import { NewPeriodicCheckInDto, NewPeriodicCheckOutDto } from '../../../types/periodic-check.dto'

export const NEW_PERIODIC_CHECK = 'NEW_PERIODIC_CHECK'
export const NEW_PERIODIC_CHECK_SUCCESS = 'NEW_PERIODIC_CHECK_SUCCESS'
export const NEW_PERIODIC_CHECK_ERROR = 'NEW_PERIODIC_CHECK_ERROR'
export const RESET_NEW_PERIODIC_CHECK = 'RESET_NEW_PERIODIC_CHECK'

export interface NewPeriodicCheck {
  type: typeof NEW_PERIODIC_CHECK
  payload: NewPeriodicCheckOutDto<any>
}

export interface NewPeriodicCheckSuccess {
  type: typeof NEW_PERIODIC_CHECK_SUCCESS
  payload: NewPeriodicCheckInDto<any>
}

export interface NewPeriodicCheckError {
  type: typeof NEW_PERIODIC_CHECK_ERROR
  payload: string | boolean
}

export interface ResetNewPeriodicCheck {
  type: typeof RESET_NEW_PERIODIC_CHECK
  payload: null
}

export interface State {
  data: NewPeriodicCheckInDto<any> | null
  states: {
    loading: boolean
    success: boolean
    error: boolean | string
  }
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
}

export type Actions = NewPeriodicCheck | NewPeriodicCheckSuccess | NewPeriodicCheckError | ResetNewPeriodicCheck
